



























import Vue from "vue"
import MaterialIcon, {
  FILLED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    MaterialIcon,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isShow: false,
      iconType: {
        FILLED,
      },
    }
  },
  methods: {
    expand() {
      this.isShow = !this.isShow
    },
  },
})
